import { Typography } from '@mui/material'
import { FlexCol, FlexGrowRow, FlexRow } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { useContext } from 'react'

import { AppSettingsContext } from '../../../Contexts'

interface Props {
  quadkey?: Quadkey
}

const TilePlayView: React.FC<Props> = (props) => {
  const { quadkey } = props
  const { developerMode } = useContext(AppSettingsContext)

  return (
    <FlexGrowRow right={10} bottom={36} position="absolute" display={quadkey && developerMode ? 'flex' : 'none'}>
      <FlexRow paper paddingX={2}>
        <FlexCol>
          <Typography>Tile: #{quadkey?.toBase4HashLabel()}</Typography>
          <Typography>Level: 5</Typography>
          <Typography>Slots: 5</Typography>
        </FlexCol>
      </FlexRow>
    </FlexGrowRow>
  )
}

export default TilePlayView
